module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAHKADAAQAAAABAAAAHAAAAABHddaYAAAA3ElEQVRIDe2WMQ7CMAxFk6oDQpyRrRtHYGBk4wRIZYa9B+BehG/USK6VShb8iCWR3NS15ddvOWpDMCuldICNsGhCfHeGYfusG671oCguyuyqAwXlaEnK50JR+KSKr93SoJ1zEvbI4w2SU6WopykN/4KeRYZjUZVeHEBJaVDnAVBpaFtrr50v6iBdbfUVnwNF8Q7WoLbLrb3q1Dtuvxkk7we4iI8xvhAYYI9iwvLhFi7npwxKe9jdTozyJdYv+T96UhBWgk50WH7XAlRgmxyvsivoszosK5ihu+zr/Q35AeYIBoOHnQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/part_9.png
// module id = T73g
// module chunks = 0